export default __webpack_public_path__ + "static/media/Group9163.44f0f936.svg";